import { io } from "socket.io-client";

export const initSocket = async () => {
  const options = {
    reconnectionAttempt: "Infinity",
    timeout: 10000,
    transports: ["websocket"],
  };

  return io("https://collab-now-server.onrender.com", options);
};
